module.exports = __webpack_public_path__ + "img/Journey_inward.7ca3fb7a.png";